/**
 * Library image pack (`public/assets/library/`).
 * @param {string} fileName
 */
export function libraryAsset(fileName) {
  const base = typeof process.env.PUBLIC_URL === "string" ? process.env.PUBLIC_URL : "";
  return `${base}/assets/library/${fileName}`;
}
